import { render, staticRenderFns } from "./TeachersOfStudent.vue?vue&type=template&id=5d51504d&"
import script from "./TeachersOfStudent.vue?vue&type=script&lang=js&"
export * from "./TeachersOfStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports